import config from '../config';
import {Authorization} from 'glxl-helpers';
const auth = new Authorization();

export default function apiCall(path, body = null, method = 'GET', opts = {}, unauthorizedRedirect = true) {
  const details = {
    method,
    headers: {},
  }
  details.crossDomain = true;
  details.headers.Authorization = sessionStorage.getItem('token') || auth.getAuthString();
  if(body) {
    if (body instanceof FormData) {
      details.body = body;
    } else {
      details.body = JSON.stringify(body);
      details.headers['Content-Type'] = 'application/json';
    }
  }
  details.headers = {
    ...details.headers,
    ...opts.headers,
  };
  return fetch(config.apiUrl+path, details)
    .then(resp => {
      // Handle forbidden
      if (resp.status === 401) {
        sessionStorage.setItem('tweedeinlog', 'true');
      }
      if ((resp.status === 403 || resp.status === 401) && unauthorizedRedirect) {
        auth.setAuthToken('');
        // cookie.setCookie('i18n', '');
        sessionStorage.removeItem('redirect');
        sessionStorage.removeItem('prevLocation');
        sessionStorage.removeItem('noMobile');
        window.location.href = '/login';
        return;
      }
      const contentType = resp.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        return resp.json();
      }
      return resp.blob();
    })
}



// WEBPACK FOOTER //
// ./src/components/apiCall.js